import { useMutation } from '@apollo/client';

import CreateReasonCodeMutation from '@/graphql/contracts/createReasonCode.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { CreateReasonCode, CreateReasonCodeVariables } from '@/graphql/contracts/_generated_/createReasonCode.mutation';
import GetPaginatedReasonCodesQuery from '@/graphql/contracts/getPaginatedReasonCodes.query.gql';
import { REASON_CODES_PER_PAGE } from '@/config/common.config';
import { notificationService } from '@/services/notification/notification.client';

export type CreateReasonCodeDto = CreateReasonCodeVariables;

export function useCreateReasonCode() {
  const [_createReasonCode] = useMutation<CreateReasonCode, CreateReasonCodeVariables>(
    CreateReasonCodeMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
      awaitRefetchQueries: true,
    }
  );

  const createReasonCode = (dto: CreateReasonCodeDto, pageNumber: number, successCallback?: Function) => {
    _createReasonCode({
      variables: { ...dto },
      onCompleted: () => successCallback?.(),
      refetchQueries: [
        {
          query: GetPaginatedReasonCodesQuery,
          variables: {
            type: dto.type,
            pageNumber: pageNumber,
            pageSize: REASON_CODES_PER_PAGE,
            includeDisabled: true
          }
        }
      ]
    });
  };

  return {
    createReasonCode
  } as const;
}
